<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row align-items-center">
            <div class="col d-flex align-items-center">
              <h4 class="me-3 my-0">{{ customer_short_name }} - zlecenia</h4>
              <Link :href="route('producents.out.index')" class="btn btn-outline-primary">
                <i class="bi bi-list"></i>&nbsp;Powrót do listy
              </Link>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="row">
            <div class="col-xl-12 mt-4">
              <div class="d-flex justify-content-end mb-3">
                <button class="btn btn-success" @click="exportProjectsToExcel">Eksportuj do Excel</button>
              </div>
              <div v-for="(project, index) in projects" :key="project.prid" class="mb-4">
                <h5 class="mb-3">
                  Projekt: {{ project.project_name }}
                  <span class="text-muted ms-3">(Wartość zlecenia: {{ formatMoney(projectTotal(project)) }} zł)</span>
                  <button class="btn btn-sm btn-outline-primary ms-3" @click="project.showTable = !project.showTable">
                    {{ project.showTable ? 'Zwiń listę' : 'Rozwiń listę' }}
                  </button>
                </h5>
                <div v-if="project.showTable" class="table-responsive">
                  <table class="table table-bordered table-striped align-middle">
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>Miniatura</th>
                      <th>Numer</th>
                      <th>Opis</th>
                      <th>Materiał</th>
                      <th>Ilość</th>
                      <th>SMART</th>
                      <th>Status</th>
                      <th>Cena</th>
                      <th>Uwagi</th>
                      <th>Data dostawy</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, idx) in project.items" :key="item.item_id">
                      <td>{{ idx + 1 }}</td>
                      <td><img :src="item.production_data?.[0]?.thumbnail || '/images/no-image.png'"
                               :alt="item.production_data?.[0]?.part_number || ''" style="width: 60px; height: auto;"/>
                      </td>
                      <td>{{ item.production_data[0]?.part_number || '' }}</td>
                      <td>{{ item.production_data[0]?.description || '' }}</td>
                      <td>{{ item.production_data[0]?.material || '' }}</td>
                      <td>{{ item.production_data[0]?.qty || '' }}</td>
                      <td>{{ item.production_data[0]?.smart || '' }}</td>
                      <td>{{ item.status_name || '' }}</td>
                      <td>{{ item.producents_data.cena || '' }}</td>
                      <td>{{ item.producents_data.uwagi || '' }}</td>
                      <td>{{ formatDate(item.producents_data.dostawa) || '' }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="mt-4">
                <h5>Łączna wartość wszystkich zleceń: {{ formatMoney(overallTotal) }} zł</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";

export default {
  components: {AppLayout},
  props: {
    users: Object,
    production_out: Array,
    projects: Array,
    customer_short_name: String
  },
  methods: {
    exportProjectsToExcel() {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/producents_out/to-excel';
      form.target = '_blank';

      const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = '_token';
      csrfInput.value = csrf;
      form.appendChild(csrfInput);
      const nameInput = document.createElement('input');
      nameInput.type = 'hidden';
      nameInput.name = 'nazwa';
      nameInput.value = this.customer_short_name;
      form.appendChild(nameInput);

      const flatData = this.projects.flatMap(project => {
        return project.items.map(item => {
          const data = item.production_data?.[0] || {};
          return {
            part_number: data.part_number || '',
            description: data.description || '',
            material: data.material || '',
            qty: data.qty || '',
            smart: data.smart || '',
            status: item.status_id || '',
            status_name: item.status_name || '',
            cena: item.producents_data?.cena || '',
            uwagi: item.producents_data?.uwagi || '',
            dostawa: item.producents_data?.dostawa || '',
            thumbnail: data.thumbnail || '',
          };
        });
      });

      const dataInput = document.createElement('input');
      dataInput.type = 'hidden';
      dataInput.name = 'data';
      dataInput.value = JSON.stringify(flatData);
      form.appendChild(dataInput);

      const statusInput = document.createElement('input');
      statusInput.type = 'hidden';
      statusInput.name = 'statusy';
      statusInput.value = JSON.stringify(this.statusy || []);
      form.appendChild(statusInput);

      const titleInput = document.createElement('input');
      titleInput.type = 'hidden';
      titleInput.name = 'title';
      titleInput.value = 'Eksport projektów';
      form.appendChild(titleInput);

      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },

    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}.${month}.${year}`;
    },
    formatMoney(value) {
      return new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: 'PLN',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    projectTotal(project) {
      return project.items.reduce((sum, item) => {
        const qty = parseFloat(item.production_data[0]?.qty) || 0;
        const cena = parseFloat(item.producents_data?.cena) || 0;
        return sum + (qty * cena);
      }, 0);
    }
  },
  computed: {
    overallTotal() {
      return this.projects.reduce((total, project) => {
        return total + this.projectTotal(project);
      }, 0);
    }
  }
}
</script>
